import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  errorGeneratingHotkeys: {
    description: 'printErrors.errorGeneratingHotkeys',
    defaultMessage: 'Error Generating Hotkeys and Barcode',
    id: 'oade6N',
  },
  hotkeysError: {
    description: 'printErrors.hotkeysError',
    defaultMessage: 'No Preset or Hotkey found.',
    id: 'FNgRqt',
  },
  errorCreatingOrderSummary: {
    description: 'printErrors.errorCreatingOrderSummary',
    defaultMessage: 'Error Creating Order Summary',
    id: 'vneGHO',
  },
  unknownError: {
    description: 'printErrors.unknownError',
    defaultMessage: 'Unknown Error',
    id: 'IIBnIE',
  },
  downloadHotkeysAndBarcodeStartedTitle: {
    description: 'printEpics.downloadHotkeysAndBarcodeStartedTitle',
    defaultMessage: 'Downloading Hotkeys and Barcodes',
    id: 'ddMMgr',
  },
  downloadHotkeysAndBarcodeStartedContent: {
    description: 'printEpics.downloadHotkeysAndBarcodeStartedContent',
    defaultMessage: 'Hotkeys and Barcodes Download Started',
    id: 'qZrJOM',
  },
  downloadHotkeysAndBarcodeCompletedTitle: {
    description: 'printEpics.downloadHotkeysAndBarcodeCompletedTitle',
    defaultMessage: 'Downloading Hotkeys and Barcodes...',
    id: 'xbRF4g',
  },
  downloadHotkeysAndBarcodeCompletedContent: {
    description: 'printEpics.downloadHotkeysAndBarcodeCompletedContent',
    defaultMessage: 'Hotkeys and Barcodes Download Completed.',
    id: 'gyVsPC',
  },
  printingHotkeysAndBarcodeSuccessTitle: {
    description: 'printEpics.printingHotkeysAndBarcodeSuccessTitle',
    defaultMessage: 'Printing Hotkeys and Barcodes...',
    id: 'bjrBH3',
  },
  printingHotkeysAndBarcodeSuccessContent: {
    description: 'printEpics.printingHotkeysAndBarcodeSuccessContent',
    defaultMessage: 'Hotkeys and Barcodes sent to {printerName}.',
    id: 'x4DNzt',
  },
});
